// extracted by mini-css-extract-plugin
module.exports = {"root":"PresentationCard_root__OQahd","title":"PresentationCard_title__2l1Jm","description":"PresentationCard_description__3kVll"};